import './Navbar.css'

function Navbar() {
    return (
        <div className="navbar">
            <div
                data-animation="default"
                data-collapse="medium"
                data-duration="400"
                data-easing="ease"
                data-easing2="ease"
                role="banner"
                className="navbar-container w-nav"
            >
                <div className="navbar-container-wrap">
                    <div className="navbar-wrapper">
                        <a href="/" aria-current="page" className="navbar-logo">
                            <img
                                src='/logo.svg'
                                loading="lazy"
                                alt=""
                                className="navbar-brand-logo"
                            />
                        </a>
                        <div className="nav-right">
                            <div className="nav-button-wrapper">
                                <a href="https://docs.google.com/forms/d/e/1FAIpQLSd7TZFAjsBXEDwsrSZPl5j3-hsNGffCJiwm01jq30J1XVdxSw/viewform?usp=sf_link" target="_blank" className="sign-up-btn w-inline-block">
                                    <div className="button-1-text">Sign Up</div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Navbar;